const REFRESH_KEY = 'ammonia-audit-sw-ready';
const DEV_SW_CLEANUP_KEY = 'ias-dev-sw-cleanup';

async function cleanupDevServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  const hasRegistrations = registrations.length > 0;
  if (hasRegistrations) {
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      if (cacheNames.length > 0) {
        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      }
    } catch {
      // ignore cache cleanup failures in dev
    }
  }

  const isControlled = Boolean(navigator.serviceWorker.controller);
  if (!isControlled && !hasRegistrations) {
    return;
  }

  try {
    if (sessionStorage.getItem(DEV_SW_CLEANUP_KEY)) {
      return;
    }
    sessionStorage.setItem(DEV_SW_CLEANUP_KEY, '1');
  } catch {
    return;
  }

  window.location.reload();
}

export function registerSW(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const pwaEnabled =
    import.meta.env.VITE_PWA_ENABLED === true || import.meta.env.VITE_PWA_ENABLED === 'true';

  if (import.meta.env.DEV && !pwaEnabled) {
    void cleanupDevServiceWorker();
  }

  // Only register PWA if virtual:pwa-register is available (production builds with PWA enabled)
  try {
    // @ts-expect-error - virtual:pwa-register module only available in PWA builds
    import('virtual:pwa-register')
      .then(({ registerSW: registerPWA }) => {
        const updateSW = registerPWA({
          immediate: false,
          onNeedRefresh() {
            const shouldReload = confirm('Aggiornamento disponibile. Vuoi ricaricare ora?');
            if (shouldReload) {
              updateSW(true);
            }
          },
          onOfflineReady() {
            if (localStorage.getItem(REFRESH_KEY)) return;
            alert("Applicazione pronta all'uso offline");
            localStorage.setItem(REFRESH_KEY, '1');
          },
        });

        window.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            updateSW();
          }
        });
      })
      .catch(() => {
        // PWA module not available, silently ignore
        console.log('PWA service worker not available in this build');
      });
  } catch {
    // PWA module not available, silently ignore
    console.log('PWA service worker not available in this build');
  }
}
